import { connect } from 'react-redux';

import GlobalHeader from 'components/common/global-header-component';

import { toggleBlacklineViewModeAndRefetchSectionsInView } from 'store/actions/blackline-view-actions';
import { setCurrentStatementContentTab } from 'store/actions/statement-content-actions';

const mapStateToProps = (
  {
    data: {
      currentUser,
      revision,
      selectedProject: { project },
      statementContent: { statementContentFilters },
      selectedStatement,
      activeUsers,
      blacklineSourceGuidList,
      blacklineTargetGuidList,
    },
    ui: {
      statementPage: {
        zoom,
        modes: { blacklineViewMode, contentViewMode },
        statementNavigatorPanel: { showNavigationRefreshButton },
      },
    },
  },
  { urlParams, summaryStatus, summary },
) => ({
  currentUser,
  revision,
  project,
  urlParams,
  summaryStatus,
  summary,
  zoom,
  statementContentFilters,
  blacklineViewMode,
  contentViewMode,
  selectedStatement,
  activeUsers,
  showNavigationRefreshButton,
  blacklineSourceGuidList,
  blacklineTargetGuidList,
});

const mapDispatchToProps = {
  setCurrentStatementContentTab,
  toggleBlacklineViewMode: toggleBlacklineViewModeAndRefetchSectionsInView,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalHeader);
